import { FixMeLater } from '../temporary-types';
import { ACCR_REQUEST_STATUS } from '../views/requests/constant';

const ACCR_REQUEST_STATUS_TRANSLATION = {
  [ACCR_REQUEST_STATUS.NEW]: 'NEW',
  [ACCR_REQUEST_STATUS.INVITED]: 'INVITED',
  [ACCR_REQUEST_STATUS.RECEIVED]: 'RECEIVED',
  [ACCR_REQUEST_STATUS.DATA_COMPLETED]: 'DATA_COMPLETE',
  [ACCR_REQUEST_STATUS.APPROVED]: 'APPROVED',
  [ACCR_REQUEST_STATUS.READY_TO_PRINT]: 'READY_TO_PRINT',
  [ACCR_REQUEST_STATUS.PRINTED]: 'PRINTED',
  [ACCR_REQUEST_STATUS.REJECTED]: 'REJECTED',
  [ACCR_REQUEST_STATUS.DELIVERED]: 'DELIVERED',
};

const YES_OR_NO = {
  YES: 'TRANSFERABILITY_ALL',
  NO: 'TRANSFERABILITY_NO',
};

export const getAccrRequestStatusTranslationKey = (
  accrRequestStatus: ACCR_REQUEST_STATUS | string,
): string => {
  return ACCR_REQUEST_STATUS_TRANSLATION[accrRequestStatus];
};

export const getYesOrNoTranslationKey = (key: FixMeLater): string => {
  return YES_OR_NO[key];
};
